var si = typeof setImmediate === 'function', tick;
if (si) {
  tick = function (fn) { setImmediate(fn); };
} else {
  tick = function (fn) { setTimeout(fn, 0); };
}

module.exports = tick;


//////////////////
// WEBPACK FOOTER
// /app/~/ticky/ticky-browser.js
// module id = ../../../../ticky/ticky-browser.js
// module chunks = 16